import { cn } from "@vc/lib/utils";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/clientWeb/components/ui/tooltip";

interface ControlButtonProps {
  active?: boolean;
  danger?: boolean;
  isMicVideo?: boolean;
  compact?: boolean;
  isToggle?: boolean;
  onClick: () => void;
  label: string;
  /** Extra classes on the button — used for the host-blocked look. */
  className?: string;
  children: React.ReactNode;
  /** Greys the button out and blocks the click, without touching any
   *  existing caller that never passes it. */
  disabled?: boolean;
}

export function ControlButton({
  active,
  danger,
  isMicVideo,
  compact = false,
  isToggle = false,
  onClick,
  label,
  className,
  children,
  disabled = false,
}: ControlButtonProps) {
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            onClick={disabled ? undefined : onClick}
            disabled={disabled}
            aria-pressed={isToggle ? (active ?? false) : undefined}
            className={cn(
              "group relative grid place-items-center rounded-full transition-all duration-200 cursor-pointer transition-all duration-300 ease-out hover:bg-slate-100 dark:hover:bg-white/10 hover:scale-105 hover:-translate-y-1 active:scale-110",
              compact ? "h-11 w-11" : "h-10 w-10",
              danger
                ? "bg-[#ea4335] hover:bg-[#d33426]"
                : active && isMicVideo
                  ? "bg-[#ea4335]/20 ring-2 ring-[#ea4335]/40 hover:bg-[#ea4335]/30"
                  : active
                    ? "bg-vc-surface-elevated/20 ring-2 ring-vc-surface-elevated/40 hover:bg-vc-surface-elevated/30"
                    : "bg-vc-surface-elevated hover:bg-vc-surface-hover",
              disabled && "opacity-60 cursor-not-allowed pointer-events-none hover:scale-100 hover:translate-y-0",
              className,
            )}
            aria-label={label}
          >
            {children}
          </button>
        </TooltipTrigger>
        <TooltipContent side="top" sideOffset={8} className="border-none capitalize">
          {label}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
